import ActivableText from './ActivableText'

export default ActivableText
